'use client';

import { SmallLotPricing } from '@ravago/shared/page-data/models/elements';
import { LeadTimeIndicator } from '@ravago/shared/page-data/models/elements/product-lead-time.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Tabs } from '@ravago/shared/radiance/components/tabs/components/Tabs/Tabs';
import { useTranslations } from '@ravago/shared/translations/client';

import { SelectedColorHeader } from './selected-color-header';
import { SmallLotPricingContent } from './small-lot-pricing-content';
import { Address } from '@ravago/shared/page-data/models/elements/address.model';

interface Props {
   pricing: SmallLotPricing;
   productName: string;
   hasMultipleSelections: boolean;
   leadTimeIndicators: LeadTimeIndicator[];
   leadTimeEnabled: boolean;
   smallLotDefaultAddress?: Address;
   onEdit: () => void;
   onRequestQuote: () => void;
}

export const SmallLotPriceView = ({
   pricing,
   productName,
   hasMultipleSelections,
   leadTimeIndicators,
   leadTimeEnabled,
   smallLotDefaultAddress,
   onEdit,
   onRequestQuote
}: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         <SelectedColorHeader
            colorName={pricing.color.name}
            producerColorCode={pricing.color.producerColorCode || undefined}
            hasMultipleSelections={hasMultipleSelections}
            onEdit={onEdit}
         />
         <Tabs
            tabs={[{ label: translate('dynamic-product-block.list-prices'), active: true }]}
            visualizeChanges={false}
         />
         <SmallLotPricingContent
            pricing={pricing}
            productName={productName}
            leadTimeIndicators={leadTimeIndicators}
            leadTimeEnabled={leadTimeEnabled}
            smallLotDefaultAddress={smallLotDefaultAddress}
            onRequestQuote={onRequestQuote}
         />
      </Box>
   );
};
